export default {
  'ordrReviews.contract.inactive.title': '顾客评价',
  'ordrReviews.contract.inactive.desc1': '提高服务质量、获取更多Google/Yelp平台好评。',
  'ordrReviews.contract.inactive.desc2': `您尚未购买<span style="color:#E00051">评价</span>服务，请联系Chowbus客户成功经理订购服务。`,
  'ordrReviews.contract.customerSuccessManager.email': `电子邮件`,
  'ordrReviews.contract.customerSuccessManager.mobile': `手机号码`,
  'orderReviews.settings.title': '评价设置',
  'orderReviews.settings.invitations.title': '邀请顾客评价',
  'orderReviews.settings.invitations.tips':
    '通过短信、小票二维码等多种形式，获取用户的用餐反馈；还可引导顾客到平台上给予餐厅评价。',

  'orderReviews.settings.basicSetting.title': '评价基础设置',

  'orderReviews.settings.basicSetting.sms.inviteCustomersForFeedback.title': '通过短信邀请评价',
  'orderReviews.settings.basicSetting.sms.inviteCustomersForFeedback.option.triggerAfterPay.title':
    '订单支付后，在发送收据时邀请评价',
  'orderReviews.settings.basicSetting.sms.inviteCustomersForFeedback.option.triggerAfterPay.tips':
    '适合餐后付费模式，发送收据时顾客已经用餐完毕。',
  'orderReviews.settings.basicSetting.sms.inviteCustomersForFeedback.option.noFeedback.title': '不通过短信邀请评价',
  'orderReviews.settings.basicSetting.receiptPromptForFeedback.title': '收据小票引导评价',
  'orderReviews.settings.basicSetting.receiptPromptForFeedback.option.title': `在收据小票上显示评价二维码，<a href="/settings/printouts?key=receipt" target="_self">请点击这里设置 ></a>`,

  'orderReviews.settings.basicSetting.inviteCustomersForFeedback.title': '邀请顾客评价',
  'orderReviews.settings.basicSetting.inviteCustomersForFeedback.enable.title': '开启',
  'orderReviews.settings.basicSetting.inviteCustomersForFeedback.disable.title': '关闭',

  'orderReviews.settings.platformSetting.title': '平台引流设置',
  'orderReviews.settings.platformSetting.guideToPlatformReview.title': '向平台引流评价',
  'orderReviews.settings.platformSetting.guideToPlatformReview.tips':
    '选择期望引流的平台，引流评分高的顾客前往平台评价，促进餐厅获取更多好评',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.google': 'Google',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.yelp': 'Yelp',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.google.placeholder': '请输入Google门店的URL',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.yelp.placeholder': '请输入Yelp门店的URL',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.preview': '预览',
  'orderReviews.settings.platformSetting.ratingStandard.title': '引流分值',
  'orderReviews.settings.platformSetting.ratingStandard.tips': '设定引流分值，引流评分高的顾客',
  'orderReviews.settings.platformSetting.ratingStandard.starsSelector.tail': '及以上评分的顾客引流到平台',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.google.invalidUrl': '无效的Google门店的URL',
  'orderReviews.settings.platformSetting.guideToPlatformReview.platform.yelp.invalidUrl': '无效的Yelp门店的URL',

  'orderReviews.details.title': '评价明细',
  'orderReviews.details.query.seachByDateRange': '按时间段查询',
  'orderReviews.details.query.seachByDateRange.default': '设为默认',
  'orderReviews.details.query.rate': '评分',
  'orderReviews.details.query.rate.placeHolder': '可多选',
  'orderReviews.details.query.guideToPlatform': '平台引流',
  'orderReviews.details.query.guideToPlatform.placeHolder': '可多选',
  'orderReviews.details.query.keywordSearch': '关键词搜索',
  'orderReviews.details.query.keywordSearch.placeHolder': '高级搜索',

  'orderReviews.report.title': '评价统计',
  'orderReviews.report.totalRating': '评分总量',
  'orderReviews.report.averageRating': '平均分值',

  'orderReviews.details.action.clear': '清除',

  'orderReviews.column.created_at': '评价时间',
  'orderReviews.column.rating': '评分',
  'orderReviews.column.guide_To_latform': '平台引流',
  'orderReviews.column.review_content': '评价内容',
  'orderReviews.column.customer_name': '顾客姓名',
  'orderReviews.column.phone_number': '顾客手机号',
  'orderReviews.column.order_number': '关联订单号',

  'orderReviews.review.imageShower.title': '评价图片',
  'orderReviews.rating.percent': 'of the {total}',
  'orderReviews.rating.legend.one_star': '1星',
  'orderReviews.rating.legend.two_star': '2星',
  'orderReviews.rating.legend.three_star': '3星',
  'orderReviews.rating.legend.four_star': '4星',
  'orderReviews.rating.legend.five_star': '5星',

  'orderReviews.settings.updateSuccess': '更新设置成功',
  'orderReviews.detail.advanceSearchPlacehold': '按评价内容关键词搜索',

  // for C client
  'orderReviews.to_c.enter.your.phonenumber': '输入手机号码',
  'orderReviews.to_c.enter.your.phonenumber.desc': `请输入您的订单电话号码，我们希望您的宝贵反馈，以帮助我们改进。`,
  'orderReviews.to_c.enter.your.phonenumber.confirm.button': '继续',
  'orderReviews.to_c.enter.anonymous.button': '匿名评价',
  'orderReviews.to_c.pleaseRate.title': '请您评分',
  'orderReviews.to_c.pleaseRate.desc': '感谢您惠顾{restaurantName}，请对我们的服务打分',
  'orderReviews.to_c.pleaseRate.continue.tips': '请继续评价，为我们留下宝贵的意见',
  'orderReviews.to_c.pleaseRate.continue.button': '提 交',
  'orderReviews.to_c.review.title': '订单评价',
  'orderReviews.to_c.review.desc': '请留下宝贵的意见和反馈',
  'orderReviews.to_c.addPicture.placeholder': '添加图片',
  'orderReviews.to_c.comments.placeholder': '写下您的感受',
  'orderReviews.to_c.comments.submit.button': '提 交',
  'orderReviews.to_c.thanks.title': '感谢您的评价！',
  'orderReviews.to_c.thanks.desc': '我们将持续改进，期待您再次光临。',
  // 'orderReviews.to_c.thanks.more.desc': '邀请您在平台上继续对我们做出评价，把我们的优点和不足，都介绍给平台上的朋友们',
  'orderReviews.to_c.thanks.more.desc': '复制您的评价内容，直接粘贴至平台的发布页。',
  'orderReviews.to_c.thanks.more.title': '让更多朋友了解我们，鞭策我们不断改进',
  'orderReviews.to_c.thanks.more.google.review.button': '前往 Google评价',
  'orderReviews.to_c.thanks.more.yelp.review.button': '前往 Yelp评价',
  'orderReviews.to_c.enter.your.phonenumber.consent': `已阅读并同意 <a href="https://www.chowbus.com/terms-of-use" target="_blank">用户协议</a> & <a href="https://www.chowbus.com/privacy-policy" target="_blank">隐私政策</a>；同意接收Chowbus优惠短信。`,

  'orderReviews.action.uploadPhoto': '上传图片',
  'orderReviews.image.description': '上传图片格式为{fileTypes}; 大小为{fileMaxSize}MB以内',
  'orderReviews.image.tooLargeSize': '图像大小需要为{fileMaxSize}MB以内',
  'orderReviews.image.tooSmallSize': '图片宽度和高度必须至少为 320 x 320',
  'orderReviews.resolutionAdjusted': '分辨率已调整',
  'orderReviews.viewOriginalPhoto': '查看原图',
  'orderReviews.handleImageFailed': '处理图片失败，请重新操作',
  'orderReviews.wrongFileType': '图片格式只能为{fileTypes}',

  'orderReviews.page.title': 'Chowbus POS订单评价',
  'orderReviews.submit.alert.backButton': '返回',
  'orderReviews.submit.alert.retryButton': '重试',
  'orderReviews.submit.alert.message': '网络请求错误，请重试提交您的评价。',

  'orderReviews.to_c.copytoClipboardButton': '复制评价内容',
  'orderReviews.to_c.copied.message': '复制完成',
};
